import { getSoftSettingLogo } from "@/services/softSetting";
import { useQuery } from "@tanstack/react-query";

function useSoftSettingLogo() {
  return useQuery({
    queryKey: ["softsettingLogo"],
    queryFn: getSoftSettingLogo,
    staleTime: 1000 * 60 * 10,
    retry: 2,
    retryDelay: 1000,
  });
}

export default useSoftSettingLogo;
